module.exports = __webpack_public_path__ + "static/img/10.Connector-of-USB-Terminal-Instruction-Head.6918dc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/10.Connector-of-USB-Terminal-Instruction-Head.jpg
// module id = G5yB
// module chunks = 1